export class ListMaintenanceRunsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "maintenanceRuns",
            "baseName": "maintenanceRuns",
            "type": "Array<MaintenanceRun>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListMaintenanceRunsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
